import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";

import { PRODUCT_STOCK_DETAILS_CONFIG_URL } from "../../../api/api_routing_urls";
import axios from "../../../api/axios";

import Button from "../../../reusable-components/buttons/Button";
import SubmitButton from "../../../reusable-components/buttons/SubmitButton";
import Input from "../../../reusable-components/inputs/InputTextBox/Input";

import { button, cancel_button } from "../../../theme/lightTheme";
import showToast from "../../../utilities/notification/NotificationModal";

const UpdateVariantStockForm = ({
  editStockDetails,
  setEditStockDetails,
  setShowAddForm,
  getProductWithStockDetailsList,
  selectedProductId,
}) => {
  const defaultValues = {
    stock_quantity: editStockDetails?.stock_quantity,
  };

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setError,
    clearErrors,
    reset,
    setValue,
  } = useForm({
    mode: "onChange",
    defaultValues: defaultValues,
    criteriaMode: "all",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const onSubmit = async (data) => {
    try {
      let response = "";
      data.stock_id = editStockDetails?.stock_id;
      response = await axios.post(PRODUCT_STOCK_DETAILS_CONFIG_URL, data);

      // console.log({ response });

      if (response.status === 200) {
        setEditStockDetails([]);
        showToast("Stock details has been updated successfully.", "success");
        getProductWithStockDetailsList(selectedProductId);
      } else {
        showToast("Stock details updation error.", "error");
      }
      setShowAddForm(false);
      reset();
    } catch (error) {
      if (!error?.response) {
        showToast("No Server Response", "error");
      } else if (error.response.status === 422) {
        showToast("Some of the required inputs were not provided.", "error");
      } else {
        showToast(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
    }
  };

  return (
    <section>
      <div className="flex flex-col bg-white border border-gray-400 p-4 rounded-md">
        <p className="text-xs font-bold">You are updating stock for: </p>
        <div className="flex gap-3">
          <p className="text-xs">{editStockDetails.product_name} - </p>
          <p className="text-xs">{editStockDetails.fabric_type_name}</p>
          <p className="text-xs">{editStockDetails.size_name}</p>
          <p className="text-xs">{editStockDetails.color_name}</p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          defaultName="stock_quantity"
          register={register}
          name="Stock Quantity"
          required={true}
          pattern={null}
          errors={errors}
          placeholder="Enter the quantity"
          setError={setError}
          clearError={clearErrors}
          autoComplete="off"
          type="number"
          classes={`rounded-lg px-3 py-2 text-sm w-full focus:outline-none focus:ring-0 focus:brder-2 focus:border-black`}
          onChangeInput={null}
          defaultValue={defaultValues.stock_quantity}
          setValue={setValue}
        />
        <div className="flex justify-between pt-2">
          <SubmitButton
            isSubmitting={isSubmitting}
            label={"Update"}
            className={button}
          />
          <Button
            onClick={() => {
              setEditStockDetails([]);
              setValue("stock_quantity", "");
              setShowAddForm(false);
            }}
            aria-label="Cancel Stock Update Button"
            className={cancel_button}
          >
            Cancel
          </Button>
        </div>
      </form>
    </section>
  );
};

export default UpdateVariantStockForm;
